module.exports = __webpack_public_path__ + "img/icon_exchange_20people.8dfad487.png";